import { useContext } from "react";

import { DrawerOverrideContext } from "../../context/sectionTabs/DrawerOverrideContext";
import type { DrawerOverrideContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: DrawerOverrideContextValue = {
  drawerOverride: null,
  setDrawerOverride: noop,
};

/**
 * Register/read the mobile shell's nav-drawer contextual-section override.
 */
export const useMobileDrawerOverride = () => {
  const context = useContext(DrawerOverrideContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileDrawerOverride: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
